(() => {
  const selector = '[data-wfs-branded-sale]';
  const cleanups = new WeakMap();

  function updateHero(hero) {
    if (!hero || !hero.isConnected) return;
    const header = document.querySelector('sticky-header.header-wrapper');
    if (!header) {
      hero.style.removeProperty('--wfs-header-clearance');
      return;
    }

    // Use the hero's document position, not its scroll-relative viewport top.
    // Otherwise a header ResizeObserver after scrolling would drag the copy down.
    const heroTop = hero.getBoundingClientRect().top + window.scrollY;
    const headerBottom = header.getBoundingClientRect().bottom;
    const clearance = Math.max(0, Math.ceil(headerBottom - heroTop + 20));
    const current = Number.parseFloat(
      hero.style.getPropertyValue('--wfs-header-clearance') || '0'
    );

    // Only write when the measured value changes. The overlay is absolute, so this
    // cannot change the hero or header dimensions observed below.
    if (Math.abs(current - clearance) > 1) {
      hero.style.setProperty('--wfs-header-clearance', `${clearance}px`);
    }
  }

  function mount(hero) {
    if (hero.dataset.wfsSaleMounted === 'true') return;
    hero.dataset.wfsSaleMounted = 'true';

    let frame = 0;
    const schedule = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = 0;
        updateHero(hero);
      });
    };

    const header = document.querySelector('sticky-header.header-wrapper');
    const observer = typeof ResizeObserver === 'function' && header
      ? new ResizeObserver(schedule)
      : null;
    if (observer) observer.observe(header);

    const imageListeners = [];
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    hero.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', schedule, { once: true });
        imageListeners.push(image);
      }
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedule).catch(() => {});
    }
    cleanups.set(hero, () => {
      window.removeEventListener('resize', schedule);
      window.removeEventListener('load', schedule);
      if (observer) observer.disconnect();
      imageListeners.forEach((image) => image.removeEventListener('load', schedule));
      if (frame) cancelAnimationFrame(frame);
    });
    schedule();
  }

  function unmount(root) {
    const heroes = [];
    if (root.matches && root.matches(selector)) heroes.push(root);
    root.querySelectorAll?.(selector).forEach((hero) => heroes.push(hero));
    heroes.forEach((hero) => {
      cleanups.get(hero)?.();
      cleanups.delete(hero);
      delete hero.dataset.wfsSaleMounted;
    });
  }

  function initialize(root = document) {
    if (root.matches && root.matches(selector)) mount(root);
    root.querySelectorAll?.(selector).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    unmount(event.target);
  });
})();
